import { CustomTooltip } from "@shared/components/CustomTooltip";
import { Card, CardContent, CardHeader, CardTitle } from "@shared/ui/card";
import { Activity } from "lucide-react";
import React from "react";
import { useGetMeterSummaryDashboard } from "../../hooks";
import { useParams } from "react-router-dom";

export const KeyStatsCard: React.FC<any> = ({ data }) => {
  const { cycle_id, route_name } = useParams();
  const { data: meterSummaryDashboardData } =
    useGetMeterSummaryDashboard(cycle_id);
  return (
    <Card>
      <CardHeader>
        <div className="flex items-center gap-2">
          <Activity className="h-5 w-5 text-green-600" />
          <CardTitle className="text-lg font-semibold">Key Stats</CardTitle>
        </div>
        <p className="text-sm text-gray-600">
          Snapshot of cycle metrics for quick assessment.
        </p>
      </CardHeader>
      <div className="mt-2">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 rounded-full bg-gray-400"></div>
            <span className="text-sm text-gray-600">Total Routes</span>
            <CustomTooltip message="The total number of routes in the system." />
          </div>
          <span className="font-semibold">{meterSummaryDashboardData?.totalRoute || 0}</span>
        </div>

        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 rounded-full bg-gray-400"></div>
            <span className="text-sm text-gray-600">Total Meters</span>
            <CustomTooltip message="The total number of meters in the system." />
          </div>
          <div className="text-right">
            <span className="font-semibold">{meterSummaryDashboardData?.cycleWiseTotal || 0}</span>
          </div>
        </div>

        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 rounded-full bg-gray-400"></div>
            <span className="text-sm text-gray-600">Assigned Meters</span>
            <CustomTooltip message="The total number of meters assigned to the system." />
          </div>
          <div className="text-right">
            <span className="font-semibold">{meterSummaryDashboardData?.cycleWiseActive || 0}</span>
          </div>
        </div>

        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 rounded-full bg-gray-400"></div>
            <span className="text-sm text-gray-600">Unassigned Meters</span>
            <CustomTooltip message="The total number of meters not assigned to the system." />
          </div>
          <span className="font-semibold">{meterSummaryDashboardData?.cycleWiseInactive || 0}</span>
        </div>
      </div>
    </Card>
  );
};
